<template>
  <el-link
    type="primary"
    @click.stop="openLink"
  >
    <el-icon
      :name="loading ? 'loading' : icon"
    />
    {{ label }}
  </el-link>
</template>
<script>
export default {
  props: {
    type: {
      required: true,
    },
    id: {
      required: true,
    },
    label: {
      required: true
    },
    icon: {
      required: false,
      default: 'view'
    }
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async openLink() {
      this.loading = true;
      try {
        const response = await axios.get(`api/receipts/${this.type}/${this.id}`, {
          responseType: 'arraybuffer',
          headers: {
            'Accept': 'application/pdf'
          },
        });

        const newBlob = new Blob([response], { type: 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }

        const data = window.URL.createObjectURL(newBlob);
        window.open(data);
      } catch (e) {
      }
      this.loading = false;
    },
  },
};
</script>
